import type { Starter } from '../Starter'

export const projectStarters: Starter[] = [
  {
    id: 'kanban-basic',
    name: 'Kanban Board',
    description: 'Boards & swimlanes',
    thumbnailUrl: '/assets/images/thumbnails/tb_kanban.svg',
    artifact: { kind: 'seed', seedId: 'kanban-basic', diagramType: 'flowchart' },
    job: ['run-project'],
    function: ['projects'],
    collaborative: ['share-view'],
    curatedBy: 'creately',
  },
  {
    id: 'retro-basic',
    name: 'Retrospective',
    description: 'Went well · improve · actions',
    thumbnailUrl: '/assets/images/thumbnails/tb_retrospective.svg',
    artifact: { kind: 'seed', seedId: 'retro-basic', diagramType: 'flowchart' },
    job: ['run-project'],
    function: ['projects'],
    collaborative: ['share-view'],
    curatedBy: 'creately',
  },
  {
    // Legacy replacement queue: native `kanban-basic` shipped; the kill
    // rule (first-edit rate) decides when this card drops.
    id: 'kanban',
    name: 'Kanban',
    description: 'Boards & swimlanes',
    thumbnailUrl: '/assets/images/thumbnails/tb_kanban.svg',
    translationKey: 'templates.names.kanban',
    artifact: { kind: 'legacy', templateId: 'IjuYT0expGG', legacyType: 'diagram/def/concept-map.js#ConceptMap' },
    job: ['run-project'],
    function: ['projects'],
    popular: true,
    replacedBy: 'kanban-basic',
    curatedBy: 'creately',
  },
  {
    id: 'retrospective',
    name: 'Retrospective',
    description: 'Team reflection board',
    thumbnailUrl: '/assets/images/thumbnails/tb_retrospective.svg',
    translationKey: 'templates.names.retrospective',
    artifact: { kind: 'legacy', templateId: '91vK8eaGtmB', legacyType: 'diagram/def/block.js#Block' },
    job: ['run-project'],
    function: ['projects'],
    replacedBy: 'retro-basic',
    curatedBy: 'creately',
  },
  {
    id: 'gantt-chart',
    name: 'Gantt Chart',
    description: 'Timeline & dependencies',
    thumbnailUrl: '/assets/images/thumbnails/tb_ganttchart.svg',
    translationKey: 'templates.names.ganttChart',
    artifact: { kind: 'legacy', templateId: 'pnVQkHp0S0F', legacyType: 'diagram/def/gantt.js#Gantt' },
    job: ['run-project'],
    function: ['projects'],
    popular: true,
    trigger: 'planning-cycle',
    curatedBy: 'creately',
  },
  {
    id: 'monthly-timeline',
    name: 'Monthly Timeline',
    description: 'Month-by-month plan',
    thumbnailUrl: '/assets/images/thumbnails/tb_monthly_timeline.svg',
    translationKey: 'templates.names.monthlyTimeline',
    artifact: { kind: 'legacy', templateId: 'ZusiE6xz7gb', legacyType: 'diagram/def/block.js#Block' },
    job: ['run-project'],
    function: ['projects'],
    popular: true,
    curatedBy: 'creately',
  },
]
